import { ProductType, WithPosition } from 'b2b-apps/core/catalog/redux/suggestions/types';
import {
  ANALYZE_SEARCH_EVENT,
  ANALYZE_SEARCH_FILTER_CHANGE,
  ANALYZE_SEARCH_FILTER_RESULTS,
  ANALYZE_SEARCH_PAGE_VIEW,
  ANALYZE_SIMILAR_SEARCH_QUERY,
  ANALYZE_SUGGESTED_CATEGORY_SEARCH,
  ANALYZE_SUGGESTED_SEARCH_RESULT_PRODUCT_CLICK,
  AnalyzeCatalogFilters,
  AnalyzeSearchEventAction,
  AnalyzeSearchFilterChangeAction,
  AnalyzeSearchPageViewAction,
  AnalyzeSimilarSearchQueryAction,
  AnalyzeSuggestedCategorySearchAction,
  AnalyzeSuggestedSearchResultProductClickAction,
  SEARCH_ACTION,
} from 'b2b-apps/shop/analytics/redux';
import { AnalyzeSearchFilterResultsAction } from './types';

const analyzeSearchEvent = (): AnalyzeSearchEventAction => ({
  type: ANALYZE_SEARCH_EVENT,
});

const analyzeSearchPageView = (): AnalyzeSearchPageViewAction => ({
  type: ANALYZE_SEARCH_PAGE_VIEW,
});

const analyzeSuggestedSearchResultProductClick = (
  product: WithPosition<ProductType>,
): AnalyzeSuggestedSearchResultProductClickAction => ({
  type: ANALYZE_SUGGESTED_SEARCH_RESULT_PRODUCT_CLICK,
  payload: {
    product,
  },
});

const analyzeSimilarSearchQuery = (): AnalyzeSimilarSearchQueryAction => ({
  type: ANALYZE_SIMILAR_SEARCH_QUERY,
});

const analyzeSuggestedCategorySearch = (
  facetName: string,
): AnalyzeSuggestedCategorySearchAction => ({
  type: ANALYZE_SUGGESTED_CATEGORY_SEARCH,
  payload: {
    facetName,
  },
});

const analyzeSearchFilterChange = (
  filterName: string, filterValue: string, filterAction: SEARCH_ACTION,
): AnalyzeSearchFilterChangeAction => ({
  type: ANALYZE_SEARCH_FILTER_CHANGE,
  payload: {
    filterName,
    filterValue,
    filterAction,
  },
});

export const analyzeSearchFilterResults = (
  {
    filterType,
    filters,
  }: AnalyzeCatalogFilters,
): AnalyzeSearchFilterResultsAction => ({
  type: ANALYZE_SEARCH_FILTER_RESULTS,
  payload: {
    filterType: filterType,
    filters: filters,
  },
});


export {
  analyzeSearchEvent,
  analyzeSearchFilterChange,
  analyzeSearchPageView,
  analyzeSimilarSearchQuery,
  analyzeSuggestedCategorySearch,
  analyzeSuggestedSearchResultProductClick,
};
